// import React, { useState } from "react";
// import '../Components/css/Navbar.css'
// import ServiceDropdown from './ServiceDropdown'
// import { HashLink as Link } from "react-router-hash-link";
// import { useNavigate } from "react-router-dom";
// import GoogleTranslate from './GoogleTranslate';
// import MobileGoogleTranslate from "./MobileGoogleTranslate";

// export default function Navbar2() {

//   const [fix, setFix] = useState(false);
//   const [isActive, setIsActive] = useState(false);
//   const navigate = useNavigate();

//   const goToSection = (id) => {
//     navigate("/");
//     setTimeout(() => {
//       document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
//     }, 150);
//   };

//   function setFixed() {
//     if (window.pageYOffset > 100) { setFix(true); } else { setFix(false); }
//   }

//   const handleClick = () => setIsActive(current => !current);
//   function handleState() { setIsActive(current => !current); }

//   window.addEventListener("scroll", setFixed);

//   return (
//     <>
//       <style>{`
//         /* ── Mobile: Earth + Hamburger sath dikhao ── */
//         .gt-mobile-only  { display: flex; align-items: center; }
//         .gt-desktop-only { display: none !important; }

//         @media (min-width: 1118px) {
//           .gt-mobile-only  { display: none !important; }
//           .gt-desktop-only { display: flex !important; align-items: center; }
//         }

//         /* ── Mobile nav__toggle: flex row override ──
//            Navbar.css mein width:32px height:32px fixed tha
//            aur children position:absolute the — yeh fix karta hai
//         */
//         @media (max-width: 1117px) {
//           .nav__toggle {
//             width: auto !important;
//             height: auto !important;
//             display: flex !important;
//             flex-direction: row !important;
//             align-items: center !important;
//             gap: 8px !important;
//             position: relative !important;
//           }
//           .nav__toggle-menu,
//           .nav__toggle-close {
//             position: static !important;
//             inset: unset !important;
//             margin: 0 !important;
//             right: unset !important;
//             font-size: 1.8rem !important;
//           }
//         }
//       `}</style>

//       <div className="container">
//         <div className="header2 header">
//           <nav className="nav container">

//             {/* ── Top bar: Logo | [🌐 Earth] [☰ Menu] ── */}
//             <div className="nav__data">
//               <div className="flexClass">
//                 <a className="nav__logo" href="/">
//                   <img
//                     src="/assets/ant_White_logo_26.png"
//                     className="logo"
//                     alt="logo"
//                     style={{ color: "#ffffff" }}
//                   />
//                 </a>
//               </div>

//               {/* Mobile: Earth icon + Hamburger toggle */}
//               <div className="nav__toggle" id="nav-toggle">
//                 <div className="gt-mobile-only">
//                   <MobileGoogleTranslate />
//                 </div>
//                 <i
//                   className={isActive
//                     ? "ri-close-line nav__toggle-close secont_color"
//                     : "ri-menu-line nav__toggle-menu secont_color"}
//                   onClick={handleClick}
//                 />
//               </div>
//             </div>

//             {/* ── Slide-in mobile menu ── */}
//             <div className={isActive ? "nav__menu show-menu" : "nav__menu"} id="nav-menu">

//               {/* Mobile menu header (logo + close) */}
//               <div className="mobile-view-menu container">
//                 <div className="flexClass">
//                   <a className="nav__logo" href="/">
//                     <img
//                       src="/assets/ant_White_logo_26.png"
//                       className="logo"
//                       alt="logo"
//                       style={{ color: "#ffffff" }}
//                     />
//                   </a>
//                 </div>
//                 <div className="mobile-view-toggle-cross">
//                   <i className="ri-close-line secont_color" onClick={handleClick} />
//                 </div>
//               </div>

//               {/* ── Nav list ── */}
//               <div className="nav-rightDiv">
//                 <ul className="nav__list container">

//                   <ServiceDropdown fix={fix} handleState={handleState} />

//                   <Link rel="canonical" to="/#customer-stories">
//                     <li className="nav__link" onClick={() => setIsActive(!isActive)}>
//                       Stories
//                     </li>
//                   </Link>

//                   <Link rel="canonical" to="/who-we-are">
//                     <li className="nav__link" onClick={() => setIsActive(!isActive)}>
//                       Who We Are
//                     </li>
//                   </Link>

//                   {/* Desktop only: translate in nav list — mobile pe hide */}


//                   <div className="letsConnectButtonDiv" onClick={handleClick}>
//                     <button
//                       onClick={() => goToSection("contact-us")}
//                       className="letsConnectButton"
//                       style={{ fontSize: '1rem', fontWeight: '600' }}
//                     >
//                       Let's Talk
//                     </button>
//                   </div>
//                   <li className="gt-desktop-only">
//                     <GoogleTranslate />
//                   </li>
//                 </ul>
//               </div>
//             </div>

//           </nav>
//         </div>
//       </div>
//     </>
//   );
// }

// import React, { useEffect, useState } from "react";
// import '../Components/css/Navbar.css'
// import ServiceDropdown from './ServiceDropdown'
// import { HashLink as Link } from "react-router-hash-link";
// import { useNavigate } from "react-router-dom";
// import GoogleTranslate from './GoogleTranslate';
// import MobileGoogleTranslate from "./MobileGoogleTranslate";
// import { useLocation } from "react-router-dom";


// export default function Navbar2() {

//   const [fix, setFix] = useState(false);
//   const [isActive, setIsActive] = useState(false);
//   const navigate = useNavigate();
//   const [showNavbar, setShowNavbar] = useState(true);

//   const location = useLocation();

//   const isWhiteBg =
//     location.pathname.includes("/customer-stories/") ||
//     location.pathname.includes("/services/");


//   let lastScrollY = window.pageYOffset;
//   const goToSection = (id) => {
//     navigate("/");
//     setTimeout(() => {
//       document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
//     }, 150);
//   };

//   function setFixed() {
//     if (window.pageYOffset > 100) { setFix(true); } else { setFix(false); }
//   }

//   const handleClick = () => setIsActive(current => !current);
//   function handleState() { setIsActive(current => !current); }

//   window.addEventListener("scroll", setFixed);
//   useEffect(() => {
//     let lastScrollY = window.pageYOffset;

//     const handleScroll = () => {
//       if (window.pageYOffset > 100) {
//         setFix(true);
//       } else {
//         setFix(false);
//       }

//       // 👇 Hide / Show logic
//       if (window.pageYOffset > lastScrollY) {
//         setShowNavbar(false); // scroll down → hide
//       } else {
//         setShowNavbar(true); // scroll up → show
//       }

//       lastScrollY = window.pageYOffset;
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   return (
//     <>
//       <style>{`
//         /* ── Mobile: Earth + Hamburger sath dikhao ── */
//         .gt-mobile-only  { display: flex; align-items: center; }
//         .gt-desktop-only { display: none !important; }

//         @media (min-width: 1118px) {
//           .gt-mobile-only  { display: none !important; }
//           .gt-desktop-only { display: flex !important; align-items: center; }
//         }

//         /* ── Mobile nav__toggle: flex row override ──
//            Navbar.css mein width:32px height:32px fixed tha
//            aur children position:absolute the — yeh fix karta hai
//         */
//         @media (max-width: 1117px) {
//           .nav__toggle {
//             width: auto !important;
//             height: auto !important;
//             display: flex !important;
//             flex-direction: row !important;
//             align-items: center !important;
//             gap: 8px !important;
//             position: relative !important;
//           }
//           .nav__toggle-menu,
//           .nav__toggle-close {
//             position: static !important;
//             inset: unset !important;
//             margin: 0 !important;
//             right: unset !important;
//             font-size: 1.8rem !important;
//           }
//         }
//       `}</style>

//       <div className="container">
//         <div className={`header2 header ${showNavbar ? "show-nav" : "hide-nav"}`}>
//           <nav className={`nav ${isWhiteBg ? "nav-white" : "nav-transparent"}`}>

//             {/* ── Top bar: Logo | [🌐 Earth] [☰ Menu] ── */}
//             <div className="nav__data">
//               <div className="flexClass">
//                 <a className="nav__logo" href="/">
//                   <img
//                     // src="https://backendtestinternal.s3.amazonaws.com/antrazal_white.png"
//                     src={isWhiteBg ? "/assets/ant_White_logo_26.png" : "https://backendtestinternal.s3.amazonaws.com/antrazal_white.png"}
//                     className="logo"
//                     alt="logo"
//                     style={{ color: "#ffffff" }}
//                   />
//                 </a>
//               </div>

//               {/* Mobile: Earth icon + Hamburger toggle */}
//               <div className="nav__toggle" id="nav-toggle">
//                 <div className="gt-mobile-only">
//                   <MobileGoogleTranslate />
//                 </div>
//                 <i
//                   className={isActive
//                     ? "ri-close-line nav__toggle-close "
//                     : "ri-menu-line nav__toggle-menu "}
//                   style={{ color: isWhiteBg ? "#3043ba" : "#fff" }}
//                   onClick={handleClick}
//                 />
//               </div>
//             </div>

//             {/* ── Slide-in mobile menu ── */}
//             <div className={isActive ? "nav__menu show-menu" : "nav__menu"} id="nav-menu">

//               {/* Mobile menu header (logo + close) */}
//               <div className="mobile-view-menu container">
//                 <div className="flexClass">
//                   <a className="nav__logo" href="/">
//                     <img
//                       src="/assets/ant_White_logo_26.png"
//                       className="logo"
//                       alt="logo"
//                       style={{ color: "#ffffff" }}
//                     />
//                   </a>
//                 </div>
//                 <div className="mobile-view-toggle-cross">
//                   <i className="ri-close-line" style={{ color: isWhiteBg ? "#3043ba" : "#fff" }} onClick={handleClick} />
//                 </div>
//               </div>

//               {/* ── Nav list ── */}
//               <div className="nav-rightDiv">
//                 <ul className="nav__list container">

//                   <ServiceDropdown fix={fix} handleState={handleState} />

//                   <Link rel="canonical" to="/#customer-stories">
//                     <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`} onClick={() => setIsActive(!isActive)}>
//                       Stories
//                     </li>
//                   </Link>

//                   <Link rel="canonical" to="/who-we-are">
//                     <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`} onClick={() => setIsActive(!isActive)}>
//                       Who We Are
//                     </li>
//                   </Link>

//                   {/* Desktop only: translate in nav list — mobile pe hide */}


//                   <div className="letsConnectButtonDiv" onClick={handleClick}>
//                     <button
//                       onClick={() => goToSection("contact-us")}
//                       // className="letsConnectButton"
//                       className={`letsConnectButton ${isWhiteBg ? "lets-connect-white" : "lets-connect-transparent"}`}
//                       style={{ fontSize: '1rem', fontWeight: '600' }}
//                     >
//                       Let's Talk
//                     </button>
//                   </div>
//                   <li className="gt-desktop-only">
//                     <GoogleTranslate />
//                   </li>
//                 </ul>
//               </div>
//             </div>

//           </nav>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useContext, useEffect, useState } from "react";
import '../Components/css/Navbar.css'
import ServiceDropdown from './ServiceDropdown'
import ProductDropdown from './ProductDropdown'
import { HashLink as Link } from "react-router-hash-link";
import { useNavigate } from "react-router-dom";
import GoogleTranslate from './GoogleTranslate';
import MobileGoogleTranslate from "./MobileGoogleTranslate";
import { useLocation } from "react-router-dom";
import VoicesHeader from '../voices/VoicesHeader';
import { isVoicesRoute } from '../voices/voicesRoutes';
import VoicesBlogsContext from '../voices/VoicesBlogsContext';

export default function Navbar2() {
  const { pathname } = useLocation();
  const blogs = useContext(VoicesBlogsContext);
  return isVoicesRoute(pathname) ? <VoicesHeader blogs={blogs} /> : <LegacyNavbar />;
}

function LegacyNavbar() {

  const [fix, setFix] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [showNavbar, setShowNavbar] = useState(true);   // initially true

  const location = useLocation();

  const isCollectionPage = ["/events", "/case-studies"].includes(location.pathname);

  const isWhiteBg = !["/", "/who-we-are"].includes(
    location.pathname.toLowerCase().replace(/\/+$/, "") || "/"
  );
   

  const goToSection = (id) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 150);
  };

  // Fixed navbar logic (optional - agar chahiye to rakh sakte ho)
  const setFixed = () => {
    setFix(window.pageYOffset > 100);
  };

  const handleClick = () => setIsActive(current => !current);

  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     // Throttle kar rahe hain for better performance
  //     if (!ticking) {
  //       window.requestAnimationFrame(() => {

  //         // 1. Fix logic (agar background change chahiye)
  //         setFixed();

  //         // 2. Sirf top pe ho tabhi navbar dikhao
  //         if (window.pageYOffset === 0) {
  //           setShowNavbar(true);   // Top pe hai → show
  //         } else {
  //           setShowNavbar(false);  // Thoda bhi neeche → hide
  //         }

  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // Initial check
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  return (
    <>
      <style>{`
        /* Tumhara mobile styling same rakh sakte ho */
        .gt-mobile-only  { display: flex; align-items: center; }
        .gt-desktop-only { display: none !important; }

        @media (min-width: 1118px) {
          .gt-mobile-only  { display: none !important; }
          .gt-desktop-only { display: flex !important; align-items: center; }
        }

        @media (max-width: 1117px) {
          .nav__toggle {
            width: auto !important;
            height: auto !important;
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            gap: 8px !important;
          }
        }
      `}</style>

      <div className="container">
        <div className={`header2 header `}>
          <nav className={`nav container ${isWhiteBg ? "nav-white" : "nav-transparent"} ${isCollectionPage ? "nav-collection-page" : ""}`}>

            {/* Top bar: Logo | Earth + Hamburger */}
            <div className="nav__data">
              <div className="flexClass">
                <a className="nav__logo" href="/">
                  <img
                    src={isWhiteBg ? "/assets/ant_White_logo_26.png" : "https://backendtestinternal.s3.amazonaws.com/antrazal_white.png"}
                    className="logo"
                    alt="Antrazal"
                  />
                </a>
              </div>

              <div className="nav__toggle" id="nav-toggle">
                <div className="gt-mobile-only">
                  <MobileGoogleTranslate />
                </div>
                <button
                  type="button"
                  className="nav__toggle-button"
                  aria-label={isActive ? "Close navigation menu" : "Open navigation menu"}
                  aria-expanded={isActive}
                  aria-controls="nav-menu"
                  onClick={handleClick}
                >
                  <i
                    className={isActive ? "ri-close-line nav__toggle-close" : "ri-menu-line nav__toggle-menu"}
                    style={{ color: isWhiteBg ? "#3043ba" : "#fff" }}
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>

            {/* Mobile Menu */}
            <div className={isActive ? "nav__menu show-menu" : "nav__menu"} id="nav-menu" >
              {/* ... mobile menu content same as before ... */}
              <div className="mobile-view-menu container" >
                <div className="flexClass">
                  <a className="nav__logo" href="/">
                    <img src="/assets/ant_White_logo_26.png" className="logo" alt="Antrazal" />
                  </a>
                </div>
                <div className="mobile-view-toggle-cross">
                  <button type="button" className="mobile-view-toggle-button" aria-label="Close navigation menu" onClick={handleClick}>
                    <i className="ri-close-line" style={{ color: isWhiteBg ? "#3043ba" : "#3043ba" }} aria-hidden="true" />
                  </button>
                </div>
              </div>

	              <div className="nav-rightDiv">
	                <ul className="nav__list container">
	                  <ServiceDropdown fix={fix} handleState={handleClick} />
	                  <ProductDropdown handleState={() => setIsActive(false)} />

                  <Link to="/#customer-stories" onClick={() => setIsActive(false)}>
                    <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}>Stories</li>
                  </Link>

                  <Link to="/case-studies" onClick={() => setIsActive(false)}>
                    <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}>Case Studies</li>
                  </Link>

                  <Link to="/events" onClick={() => setIsActive(false)}>
                    <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}>Events</li>
                  </Link>

                  <Link to="/who-we-are" onClick={() => setIsActive(false)}>
                    <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}>Who We Are</li>
                  </Link>

                  <Link to="/careers" onClick={() => setIsActive(false)}>
                    <li className={`nav__link ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}>Careers</li>
                  </Link>

                  <div className="letsConnectButtonDiv" onClick={handleClick}>
                    <button
                      onClick={() => goToSection("contact-us")}
                      className={`letsConnectButton ${isWhiteBg ? "lets-connect-white" : "lets-connect-transparent"}`}
                    >
                      Let's Talk
                    </button>
                  </div>

                  <li className="gt-desktop-only">
                    <GoogleTranslate />
                  </li>
                </ul>
              </div>
            </div>

          </nav>
        </div>
      </div>
    </>
  );
}
